import { BlankState } from '@domain-group/suit-theme'

import BlankStateImageUrl from './assets/no-statement-history.svg'

const StatementHistoryBlankState = () => (
  <BlankState boxProps={{ marginBottom: 'large' }} imageUrl={BlankStateImageUrl}>
    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Title>
      No Accounting History
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Title>

    {/*
     // @ts-expect-error TS2339 */}
    <BlankState.Paragraph>
      This campaign has no accounting activity yet. By approving invoices and ordering products,
      your accounting overview will receive more financial details surrounding the spending and accounting.
      {/*
     // @ts-expect-error TS2339 */}
    </BlankState.Paragraph>
  </BlankState>

)

export default StatementHistoryBlankState
